<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label" v-if="userInfo.userType === 1">
                <span>所属商家：</span>
            </div>
            <div class="form-input" v-if="userInfo.userType === 1">
                <Select v-model="formParam.merchantId" filterable clearable>
                    <Option v-for="item in merchants" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加角色</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="setAuth(row)">权限</Button>
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增角色"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules">
                    <FormItem label="角色名称" prop="name">
                        <Input v-model="formItem.name" placeholder="请输入门店名称"></Input>
                    </FormItem>
                    <FormItem label="所属商家" prop="merchantId" v-if="userInfo.userType === 1">
                        <Select v-model="formItem.merchantId" filterable>
                            <Option v-for="item in merchants" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注" prop="address">
                        <Input v-model="formItem.remark" placeholder="请输入备注"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="authSetting"
            title="权限设置"
            :styles="{top: '40px'}"
            footer-hide>
            <div>
                <div class="tree-container">
                    <Tree :data="menus" show-checkbox expand-node check-strictly @on-check-change="onTreeChange"></Tree>
                </div>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleAuthOk">确定</Button>
                    <Button @click="handleAuthCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {queryMerchantList, queryRoleMenuList, queryRolePage, removeRole, saveRole, saveRoleMenu} from "@/api"

export default {
    name: "StoreManage",
    data() {
        return {
            formParam: {
                name: '',
                merchantId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                merchantId: '',
                remark: '',
            },
            modal: false,
            authSetting: false,
            loading: false,
            rules: {
                name: [
                    {required: true, message: '角色名称不能为空', trigger: 'blur'},
                ],
                merchantId: [
                    {required: true, message: '所属商家不能为空', trigger: 'change'},
                ],
            },
            columns: [
                {
                    title: '角色名称',
                    key: 'name',
                    align: 'left',
                    width: 250,
                },
                {
                    title: '来源',
                    key: 'merchantId',
                    align: 'center',
                    render: this.renderMerchantName,
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 250,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 250,
                    align: 'center',
                },
            ],
            tableData: [],
            merchants: [],
            userInfo: {},
            menus: [],
            currentRole: {},
            selectMenus: [],
            menuChange: false,
        }
    },
    created() {
        this.userInfo = JSON.parse(sessionStorage.getItem('current-user'))
        this.queryMerchantList()
    },
    mounted() {
        this.onQuery()
    },
    methods: {
        async initTree() {
            let {data} = await queryRoleMenuList(this.currentRole)
            let ms = []
            // eslint-disable-next-line no-restricted-syntax
            for (let menu of this.$store.state.menuItems) {
                if (!menu.hidden) {
                    ms.push(menu)
                }
            }
            for (let i = 0; i < ms.length; i++) {
                this.setNodeTitle(data, ms[i])
            }
            this.menus = ms
        },
        setNodeTitle(data, node) {
            if (node) {
                node.title = node.text
                node.expand = true
                this.$set(node, 'checked', this.hasAuth(data, node.id))
                if (node.children) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (let child of node.children) {
                        this.setNodeTitle(data, child)
                    }
                }
            }
        },
        renderMerchantName(h, param) {
            let id = param.row.merchantId
            if (id === 0) {
                return h('span', '平台')
            }
            for (let i = 0; i < this.merchants.length; i++) {
                if (this.merchants[i].id === id) {
                    return h('span', this.merchants[i].name)
                }
            }
            return h('span', '平台')
        },
        hasAuth(rmList, menuId) {
            for (let i = 0; i < rmList.length; i++) {
                if (rmList[i].menuId === menuId) {
                    return true
                }
            }
            return false
        },
        async onQuery() {
            let res = await queryRolePage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        async queryMerchantList() {
            let {data} = await queryMerchantList()
            this.merchants = data
            const item = {id: 0, name: '平台'}
            this.merchants.unshift(item)
        },
        async showModal() {
            this.formItem = {
                name: '',
                merchantId: '',
                contactsName: '',
                contactsPhone: '',
                address: '',
            }
            this.modal = true
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate((valid) => {
                if (valid) {
                    saveRole(this.formItem).then(() => {
                        this.modal = false
                        this.onQuery()
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleAuthOk() {
            let param = {
                roleInfo: this.currentRole,
                menuInfoList: this.selectMenus,
                menuChange: this.menuChange,
            }
            saveRoleMenu(param).then(() => {
                this.authSetting = false
            }).finally(() => {
                this.loading = false
            })
        },
        handleCancel() {
            this.modal = false
        },
        handleAuthCancel() {
            this.authSetting = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.formItem.merchantId = row.merchantId + ''
            this.modal = true
        },
        setAuth(row) {
            this.menuChange = false
            this.currentRole = row
            this.initTree()
            this.authSetting = true
        },
        async remove(row) {
            await removeRole(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        onTreeChange(selectedNodes) {
            this.selectMenus = selectedNodes
            this.menuChange = true
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}

.tree-container {
    max-height: 460px;
    overflow: auto;
    margin-bottom: 10px;
}
</style>
